import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 17\" id=\"search\"><g stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\"><circle opacity=\".99\" cx=\"7.385\" cy=\"7.385\" r=\"6.385\" /><path d=\"M12.33 12.445l3.281 3.184\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id